import React from 'react';
import { FlatList, Image } from 'react-native';
import { Icons } from '../../Components';
import type { CodeRequestProps, MyPlayerProps, PlayerReferralProps, PromoProps, PublicPlayerProps } from '../../types';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type BasicStatusProps = {
    player:MyPlayerProps,
    width:number,
    code_details: {
        code_request?:CodeRequestProps,
        referrer?:PublicPlayerProps,
        promo?:PromoProps,
        player_referral?:PlayerReferralProps
    }
    onClose:() => void,
    onVerify:() => void
}
const sections = ['image'];
const BasicStatus = ({ onVerify, width, code_details, player, onClose }:BasicStatusProps) => {
    const C = useColors();
    const { code_request, promo } = code_details;

    const MAX_WIDTH = 500
    const size = width > MAX_WIDTH ? MAX_WIDTH : width
    const getStatus = (p:MyPlayerProps) => {
        let errors:string[] = []
        if(!p.first_name || !p.last_name){ errors.push('A first and last name are required to use real money') }
        if(p.no_password){ errors.push('A password is required to use real money') }
        return errors
    }

    const errors = getStatus(player);

    const renderSections = (data: { item:string, index:number }) => {
        switch(data.item){
            case 'image':
                return (
                    <View style={{ justifyContent:'center', alignItems:'center' }}>
                        <Image
                            source={{ uri:'https://res.cloudinary.com/hoabts6mc/image/upload/v1714410165/Welcome_banner_bqu6cc.webp' }}
                            style={{ width:size, height:size, borderRadius:4 }}
                            resizeMode='cover'
                        />
                    </View>
                )
            default: return <></>
        }
    }

    return (
        <View style={{ flex:1 }}>
            <View style={{ flex:1 }}>
                <FlatList
                    data={sections}
                    key={'status_sections'}
                    keyExtractor={(item) => item}
                    renderItem={renderSections}
                /> 
            </View>
            <View type='header' style={{ padding:10  }}>
                <View transparent style={{ padding:10, flexDirection:'row', borderBottomWidth:1, borderColor:C.borders.light }}>
                    <Icons.CheckCirlceIcon color={C.text.success} size={32}/>
                    <View transparent style={{ flex:1, marginLeft:20 }}>
                        <Text theme='h1'>FREE TO PLAY - ENGAGED!</Text>
                        <Text style={{ marginTop:5 }} theme='h2'>Your profile is ready to go for play money betting and all our FREE TO PLAY games.</Text>
                    </View>
                </View> 
                {player.vouched_status != 'verified' ? 
                <View transparent style={{ padding:10, flexDirection:'row' }}>
                    <Icons.AlertIcon color={C.text.warning} size={32}/>
                    <View transparent style={{ flex:1, marginLeft:20 }}>

                    <Text theme='h1'>WANT TO USE REAL MONEY?</Text>
                    {errors.length == 0 ?
                    <Text style={{ marginTop:5 }} theme='description'>Continue on your journey and complete the verification steps in just a couple minutes.</Text>
                    :
                    <View transparent style={{ marginTop:5 }}>
                        <Text size={14} theme='warning'>FIX THE FOLLOWING BEFORE CONTINUING</Text>
                        <View transparent style={{ padding:10 }}>
                            {errors.map((e,i) => {
                                return (
                                    <Text style={{ padding:2 }} theme='warning'>{i+1} - {e}</Text>
                                )
                            })}
                        </View>
                    </View>
                    }
                    </View>
                </View>
                :
                <View style={{ padding:10, flexDirection:'row' }}>
                    <Icons.CheckCirlceIcon color={C.text.success} size={32}/>
                    <View style={{ flex:1, marginLeft:20 }}>
                        <Text theme='h1'>REAL MONEY - ENGAGED!</Text>
                        <Text style={{ marginTop:5 }} theme='h2'>Way to go! Your profile is ready to go for real-money activities!</Text>
                    </View>
                </View> 
                }
            </View> 
            {code_request && !['closed','fulfilled'].includes(code_request.status) && promo ?
            <View float style={{ margin:15, flexDirection:'row' }}>
                <View transparent style={{ padding:10, justifyContent:'center' }}>
                    <Icons.GiftIcon size={40} color={C.text.gold} />
                </View>
                <View transparent style={{flex:1, padding:10 }}>
                    <Text theme='h1'>Verify to claim your gift!</Text>
                    <Text style={{ paddingTop:5 }} theme='h2'>Did you know on average it only takes 3 minutes to complete the verification process?</Text>
                </View>
            </View>
            :<></>}

            {player.vouched_status != 'verified' ?
            <View nativeID='action_row' style={{ flexDirection:'row', padding:10 }}>
                <Button
                    title='DO IT LATER'
                    style={{ flex:3, marginRight:5 }}
                    type='close'
                    onPress={() => onClose()}
                />
                <Button
                    title='VERIFY ACCOUNT'
                    style={{ flex:5, opacity: errors.length > 0 ? 0.5 : 1 }}
                    disabled={errors.length > 0}
                    type='success'
                    onPress={() => onVerify()}
                />
            </View>
            :
            <View nativeID='action_row' style={{ flexDirection:'row', padding:10 }}>
                <Button
                    title='CLOSE'
                    style={{ flex:3, marginRight:5 }}
                    type='close'
                    onPress={() => onClose()}
                />
            </View>
            }
        </View>
    )
}

export default BasicStatus